import React, {Fragment, useState} from 'react';

import { Tabs } from 'react-bulma-components';

const ContentTabs =   ({active, children, onTabClick=null}) => {
  const onClickTabItem = (tab) => {
     if(onTabClick){
     onTabClick(tab.target.text);
    } 
  }
  return (
    <Fragment>
    <Tabs
      type={'boxed'}
      fullwidth={false}
      className={'pagebg'}
    >
      {children.map((child, index) => {
            return (
              <Tab
                label={child.props.label}
                activeTab={active}
                onClick={onClickTabItem}
                key={child.props.label}
                disabled={child.props.disabled}
              />
            );
          })}
    </Tabs>
    {children.map((child) => {
            if (child.props.label !== active) return undefined;
            return child.props.children;
          })}
    </Fragment>
  )
}
const Tab = ({label, activeTab, onClick, disabled}) => {
  //className={data.songStepById.practice.length===0?"tab_button_is-disabled":""}
  if(disabled){
    return <></>;
  }
  return (
    <Tabs.Tab active={label===activeTab} onClick={onClick}>
        {label}
    </Tabs.Tab>
    
  )
}


export { ContentTabs, Tab };